const BACKEND_URL = "https://api.blog.lumitus.com.vn";
// const BACKEND_URL = "http://127.0.0.1:8000";

export default {
  BACKEND_URL: BACKEND_URL,

  AUTH: `${BACKEND_URL}/admin/auth`,
  CATEGORIES: `${BACKEND_URL}/admin/categories`,
  SEARCH_CATEGORY: `${BACKEND_URL}/admin/categories/search`,
  POSTS: `${BACKEND_URL}/admin/posts`,
  SEARCH_POSTS: `${BACKEND_URL}/admin/posts/search`,
  UPLOAD: `${BACKEND_URL}/admin/upload`,
  FEEDBACK: `${BACKEND_URL}/admin/feedback`,

  ADVISE: `${BACKEND_URL}/admin/need-advise`,
  SUBSCRIBE: `${BACKEND_URL}/admin/subscribe`,
  BANNER: `${BACKEND_URL}/admin/banner`,
  BANNER_PAGE: `${BACKEND_URL}/admin/banner-page`,
  PODCAST: `${BACKEND_URL}/admin/podcast`,
};
